import { Button, Divider } from "../../../components/elements"
import { Consent } from "../../../components/form"
import { ContactFields } from "../../../features/contact"

import { FieldValues, useFormContext } from "react-hook-form"
import { TitleGroup } from "./components/TitleGroup"
import { BottomErrorSpan, Container, StyledSpan } from "./styles"

interface IFormLayoutProps {
  onSubmit: (e: React.FormEvent) => void
  questionFields: React.ReactNode
  subtitle: string
  title: React.ReactNode
}

const FormLayout = <T extends FieldValues>(props: IFormLayoutProps) => {
  const methods = useFormContext<T>()

  const { onSubmit, questionFields, subtitle, title } = props

  return (
    <Container>
      <TitleGroup title={title} subtitle={subtitle} />

      <Divider />

      <form onSubmit={onSubmit}>
        {questionFields}
        <Divider />
        <StyledSpan>
          次のページで、コスト削減シミュレーション結果をご確認いただけます。
        </StyledSpan>
        <ContactFields />

        <Consent />

        <Button disabled={methods.formState.isSubmitting}>
          {methods.formState.isSubmitting
            ? `計算中...`
            : `上記に同意して結果を見る`}
        </Button>

        {methods.formState.errors.root?.apiError?.type === "client" && (
          <BottomErrorSpan>
            {methods.formState.errors.root.apiError.message}
          </BottomErrorSpan>
        )}
      </form>
    </Container>
  )
}

export { FormLayout }
